import template from './add_overtime_rules.html';
import tr from '../../lib/default-translator.js';

class AddOverTimeRulesViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.employees = ko.observableArray();
		this.select_individual = ko.observable(false);
		this.overtime_rules = ko.observableArray();
		this.overtime_type = ko.observable();
		this.overtime_id = ko.observable();
		this.multiplier = ko.observable();
		this.view_only = ko.observable(false);
		this.current_employee_id = ko.observable();
		this.selected_employee = ko.observable();
		this.department_id = ko.observable();
		this.select_all_weekdays = ko.observable(false);
		this.weekdays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
		this.company_id = ko.observable();
		this.transaction_types = ko.observableArray();
		this.transaction_type_id = ko.observable();
		this.applicable_workdays = ko.observableArray(['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']);
		this.selected_workdays = ko.observableArray([]);
		this.holiday = ko.observable(false);
		this.selected_employee.subscribe((newValue) => {
			if (newValue != null)
				this.current_employee_id(newValue.employee_id);
			else
				this.current_employee_id(null);
		});
		this.selected_workdays.subscribe((newValue) => {
			// Check if all weekdays (Mon-Fri) are selected
			let all_weekdays_selected = this.weekdays.every(day =>
				newValue.includes(day)
			);         
			if (this.select_all_weekdays() !== all_weekdays_selected) {
				this.select_all_weekdays(all_weekdays_selected);
			}
		});
		this.select_all_weekdays.subscribe((newValue) => {
			if (newValue) {
				// Select only Monday through Friday
				this.selected_workdays(this.weekdays.slice());
			} else {
				// Deselect all workdays
				this.selected_workdays([]);
			}
		});
	}
	close()
	{
		this.dialog.close();
	}

	async save_entry()
	{
		let overtime_type = this.overtime_type();
		if (!overtime_type)
			Grape.alerts.alert({ type: 'info', title: tr("Info"), message: tr("Please select or add an overtime type.")});
		let data = {
			department_id: this.department_id(),
			employee_id: this.selected_employee() || null,
			overtime_type: overtime_type,
			multiplier: parseFloat(this.multiplier()),
			applicable_workdays: this.selected_workdays(),
			overtime_id: this.overtime_id(),
			holiday: this.holiday(),
			overtime_transaction_type_id: this.transaction_type_id(),
		};
		let res = await Grape.fetches.postJSON('time_management/save_overtime_rule', data);

		if (res.status === 'OK') {
			Grape.alerts.alert({ type: 'success', message: tr('Successfully saved overtime rule.'), title: tr('Success') });
			this.close();
		} else {
			Grape.alerts.alert({ type: 'error', message: 'Error saving Overtime rule' });
		}
	}
}

class AddOverTimeRulesPage
{
	constructor (bindings)
	{
		this.bindings = bindings.row ? bindings.row : bindings;
		this.viewModel = new AddOverTimeRulesViewModel(this);
	}

	async init()
	{
		this.viewModel.department_id(this.bindings.department_id || null);
		this.viewModel.company_id(this.bindings.company_id || null);

		await this.get_transaction_types();

		if (this.bindings.overtime_id)
		{
			this.viewModel.overtime_id(this.bindings.overtime_id);
			this.viewModel.overtime_type(this.bindings.overtime_type || '');
			this.viewModel.multiplier(this.bindings.multiplier || null);
			this.viewModel.holiday(this.bindings.holiday === 't' || this.bindings.holiday === true);

			if (this.bindings.overtime_transaction_type_id)
				this.viewModel.transaction_type_id(this.bindings.overtime_transaction_type_id);

			if (this.bindings.applicable_workdays)
			{
				let workdays = this.bindings.applicable_workdays.replace(/[{}]/g, '').split(',').map(day => day.trim());
				this.viewModel.selected_workdays(workdays);
			}
			else 
				this.viewModel.selected_workdays([]);

			if (this.bindings.employee_id)
			{
				this.viewModel.select_individual(true);
				this.viewModel.selected_employee({
					employee_id: this.bindings.employee_id,
				});
			}
		}
		else
		{
			this.viewModel.overtime_id(null);
			this.viewModel.overtime_type('');
			this.viewModel.multiplier(null);
			this.viewModel.selected_workdays([]);
			this.viewModel.holiday(false);
			this.viewModel.select_individual(false);
			this.viewModel.selected_employee(null);
		}

		let res = await Grape.fetches.getJSON("/api/record", {
			table: "v_overtime_rules",
			schema: "savanna",
			filter: [
				{
				value: this.viewModel.department_id(),
				operand: "=",
				field: 'department_id',
				}
			]
		});

		if (res?.records) 
			this.viewModel.overtime_rules(res.records);
	}

	async get_transaction_types()
	{
		//get all the employees
		let filter = [{
				value: this.viewModel.company_id(),
				op: '=',
				field: 'company_id',
			},
			{
				value: 'true', op: '=', field: 'active' 
			}];

		let res = await Grape.fetches.getJSON('/api/record', {
			table: 'transaction_type_payroll_sync',
			schema: 'public',
			limit: 1000000,
			filter: filter,
		});
		if (res.records != null)
			this.viewModel.transaction_types(res.records);
	};
}

export default {
	name: 'AddOverTimeRules',
	dialog_class: AddOverTimeRulesPage,
	template: template,
	template_filename: 'translation/dialogs/add_over_time_rules',
	provider: 'ps'
};
